"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ContentBlocks;
const react_1 = __importDefault(require("react"));
const KevelAnalytics_1 = __importDefault(require("../KevelAnalytics/KevelAnalytics"));
const NewRelic_1 = __importDefault(require("../NewRelic/NewRelic"));
const ContentBlockCard_1 = __importDefault(require("../ContentBlockCard/ContentBlockCard"));
const PremiumContentBlockCard_1 = __importDefault(require("../PremiumContentBlockCard/PremiumContentBlockCard"));
const ContentBlocks_module_scss_1 = __importDefault(require("./ContentBlocks.module.scss"));
function ContentBlocks({ data }) {
    if (data.length === 0) {
        return null;
    }
    const hasPremiumContentBlock = data.some((block) => block.designType === "PremiumContentBlock");
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { "data-testid": "content-blocks-container", className: `${ContentBlocks_module_scss_1.default.blockContainer} ${hasPremiumContentBlock ? ContentBlocks_module_scss_1.default.blockContainerPremium : ""}` }, data.map((block) => (react_1.default.createElement("div", { key: block.associatedAdvertId, "data-kevel-banner-ad-id": block.associatedAdvertId, "data-testid": `content-block-${block.slotNumber}`, className: ContentBlocks_module_scss_1.default.block },
            block.designType === "PremiumContentBlock" ? (react_1.default.createElement(PremiumContentBlockCard_1.default, Object.assign({}, block))) : (react_1.default.createElement(ContentBlockCard_1.default, Object.assign({}, block))),
            react_1.default.createElement(NewRelic_1.default, { adId: block.associatedAdvertId, esiType: "category" }))))),
        react_1.default.createElement(KevelAnalytics_1.default, { events: data.map((block) => ({
                adId: block.associatedAdvertId,
                type: "banner",
                clickUrl: block.clickUrl,
                impressionUrl: block.impressionUrl,
                esiType: block.esiType,
            })) })));
}
